<template>
    <div class="col-12 mt-2">
        <Field v-model="formData.params.short_description" :errorMessage="errorMessages.short_description"
            :label="i18n('Short description')" :disabled="submitted" :type="readonly ? 'readonly' : 'text'" />
    </div>

    <div class="col-12 mt-2">
        <Field v-model="formData.params.description" :errorMessage="errorMessages.description"
            :label="i18n('Description')" :disabled="submitted" :type="readonly ? 'readonly' : 'textarea'" />
    </div>

    <div class="col-12 mt-2">
        <a class="btn btn-link" @click="showVars = !showVars">
            {{ showVars ? i18n('Hide variables') : i18n('Show variables') }}
        </a>
        <div v-if="showVars == true">
            <div class="toogle" v-for="triggerTypeParam in triggerType.triggerTypeParams" :key="triggerTypeParam">
                <div class="text-muted col-4">
                    {{ "{" + triggerTypeParam.param_name + "}" }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Field from "@/components/common/form/Field.vue";

export default {
    components: {
        Field,
    },
    data() {
        return {
            showVars: false,
            operationTypes: [],
        };
    },
    props: {
        submitted: {
            type: Boolean,
            required: true
        },
        readonly: {
            type: Boolean,
            required: true
        },
        formData: {
            type: Object,
            required: true
        },
        errorMessages: {
            type: Object,
            required: true
        },
        triggerType: {
            type: Object,
            required: true
        },
    },
    methods: {}
};
</script>